export const SPRING_EASING = "cubic-bezier(.2,.8,.3,1.2)";
export const TAB_MOTION_MS = 220;
export const PERIOD_MOTION_MS = 220;
export const PERIOD_TRAVEL_PX = 24;
export function installFeelTokens(): void {
  for (const [name, value] of Object.entries({ spring: SPRING_EASING, tab: `${TAB_MOTION_MS}ms`, select: `${SELECT_MS}ms`, row: `${ROW_EXIT_MS}ms`, period: `${PERIOD_MOTION_MS}ms`, travel: `${PERIOD_TRAVEL_PX}px` })) document.documentElement.style.setProperty(`--feel-${name}`, value);
}
export const SELECT_MS = 180;
export const TOAST_EXIT_MS = 180;
export const ROW_EXIT_MS = 200;
export const HERO_COUNT_MS = 600;
/** Integer cents throughout the opening count, including its exact final frame. */
export function countCents(final: number, progress: number): number {
  const clamped = Math.min(1, Math.max(0, progress));
  if (clamped === 0) return 0;
  return Math.round(final * (1 - (1 - clamped) ** 3));
}
